<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	<!-- <p class="title-xs font-serra my-4">Scraping card Tool</p> -->
	<h1 class="my-4">Scraping card Tool</h1>
	<label class="input input-bordered input-lg w-full gap-2">
	  <input 
	  	type="text"
	  	class="grow placeholder:text-base-content/60"
	  	placeholder="Recherchez un set..."
	  	#searchable="searchable"
	  	[(ngModel)]="qSearch"
	  	[search]="getSearchObs()"
	  	[qSearch]="qSearch()"
	  	[length]="25"
	  	[(results)]="sets"
	  	[(searching)]="loading"
	  />
	  <span (click)="searchable.search()" class="opacity-60"><i class="fa-light fa-sliders"></i></span>
	</label>

	<div class="mt-4 overflow-x-auto">
	  <table class="table">
	    <!-- head -->
	    <thead>
	      <tr>
			<th>Symbol</th>
			<th>Logo</th>
			<th>Name</th>
			<th>Nb cards</th>
			<th>Import</th>
	      </tr>
	    </thead>
	    <tbody>
	      <!-- row -->
	      @for(remoteSet of sets(); track remoteSet.id){
		      <tr>
		      	<td>
		      		@if(remoteSet.symbol){
		      			<img class="img-symbol" [src]="remoteSet.symbol"/>
		      		}
		      	</td>
		      	<td>
		      		@if(remoteSet.logo){
		      			<img class="img-logo" [src]="remoteSet.logo"/>
		      		}
		      	</td>
		        <td>
	              <div class="nowrap font-bold">{{remoteSet.name}}</div>
	              @if(remoteSet.lastUpdate){
		              <div class="text-sm opacity-50">{{remoteSet.lastUpdate | date:'dd/MM/yyyy HH:mm'}}</div>
		          }
		        </td>
		        <td>
		        	{{remoteSet.nbCards}}
		        </td>
		        <td>
		          <a href="#" [routerLink]="router.parse('scrap-set', [remoteSet.id])" class="btn btn-ghost btn-xs">
		          	<i class="icon-import fa-regular fa-download text-primary"></i>
		          </a>
		        </td>
		      </tr>
		  }
	    </tbody>
	  </table>
	</div>

	<div class="pagination mt-4">
		<div class="join">
		  @if(searchable.canPrev()){
	  	  	<button (click)="searchable.prev()" class="join-item btn">«</button>
	  	  }
		  <button class="join-item btn">Page {{searchable.page()+1}}</button>
		  @if(searchable.canNext()){
		  	<button (click)="searchable.next()" class="join-item btn">»</button>
		  }
		</div>
	</div>
</div>